<!--业绩查询-->
<template>
  <div class="PerformanceQuery">
    <app-breadcrumb/>
    <div class="page-container">
      <div class="filter">
        <el-form :inline="true" :model="listQuery" label-width="120px" size="mini">
          <!--经销商编号-->
          <el-form-item :label="$t('miMember.memberNo')">
            <el-input v-model.trim="listQuery.memberNo"/>
          </el-form-item>
          <!--期数-->
          <el-form-item :label="$t('PoOrder.periodWeek')">
            <!-- 期数起始 -->
            <el-select
                v-model="listQuery.fromWeek"
                v-loading="wWeekLoading"
                clearable
                filterable
                placeholder=""
                style="width: 120px;"
            >
              <el-option v-for="role in listdata" :key="role.id" :label="role.wWeek" :value="role.wWeek"/>
            </el-select>
            &nbsp;&nbsp; - &nbsp;&nbsp;
            <!-- 期数结束 -->
            <el-select
                v-model="listQuery.toWeek"
                v-loading="wWeekLoading"
                clearable
                filterable
                placeholder=""
                style="width: 120px;"
            >
              <el-option v-for="role in listdata" :key="role.id" :label="role.wWeek" :value="role.wWeek"/>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left:10px;">
            <el-button :loading="btnLoading" icon="el-icon-search" plain type="primary" @click="handleFilter">
              {{ $t('operation.button.search') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table v-loading="loading" :data="list" border fit size="mini" stripe style="width: 100%">
        <!--期次-->
        <el-table-column :label="$t('PoOrder.periodWeek')" align="center" prop="wWeek"/>
        <!--级别-->
        <el-table-column :label="$t('commond.levelType')" align="center">
          <template v-slot="{row}">
            {{ $lt('cn.member.level', row.newLevelType) }}
          </template>
        </el-table-column>
        <!--个人业绩-->
        <el-table-column :label="$t('mimember.onesell')" align="center" prop="perSellLocal"/>
        <!--重销业绩-->
        <el-table-column :label="$t('miagent.sell.consal')" align="center" prop="consumSellLocal"/>
        <!--市场业绩-->
        <el-table-column :label="$t('mi.member.perSell')" align="center" prop="pointAdd"/>
        <!--累计业绩-->
        <el-table-column :label="$t('miagent.add.sell')" align="center" prop="point"/>
        <!--A市场-->
        <el-table-column :label="$t('A.market')" align="center" prop="memA"/>
        <!--A业绩-->
        <el-table-column :label="$t('A.performance')" align="center" prop="pointA"/>
        <!--A累计-->
        <el-table-column :label="$t('A.accumulation')" align="center" prop="ljPointA"/>
        <!--B市场-->
        <el-table-column :label="$t('B.market')" align="center" prop="memB"/>
        <!--B业绩-->
        <el-table-column :label="$t('B.performance')" align="center" prop="pointB"/>
        <!--B累计-->
        <el-table-column :label="$t('B.accumulation')" align="center" prop="ljPointB"/>
        <!--C市场-->
        <el-table-column :label="$t('C.market')" align="center" prop="memC"/>
        <!--C业绩-->
        <el-table-column :label="$t('C.performance')" align="center" prop="pointC"/>
        <!--C累计-->
        <el-table-column :label="$t('C.accumulation')" align="center" prop="ljPointC"/>
        <!--重销保留-->
        <el-table-column :label="$t('miagent.keep.consal')" align="center" prop="lastConSell"/>
      </el-table>
      <pagination :limit.sync="listQuery.limit" :page.sync="listQuery.page" :total="total" @pagination="getList"/>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import {bdBonusMemberSellChinas} from "@/api/ay-personal-center/personalcenter"
// import getwWeek from '@/api/home'

export default {
  name: 'PerformanceQuery',
  components: {Pagination},
  data() {
    return {
      btnLoading: false,
      wWeekLoading: false,
      loading: false,
      listdata: [],
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 10,
        fromWeek: '',
        toWeek: ''
      },
    }
  },
  created() {
    this.getWeeks()
    this.listdata = JSON.parse(sessionStorage.getItem('wWeekLocalList'))
  },
  methods: {
    getList() {
      if (this.listQuery.memberNo == null && this.listQuery.memberNo === '') {
        this.$message({
          message: this.$t('required.input.memberNo'),
          type: 'warning'
        });
        return false
      }
      this.listLoading = true
      this.btnLoading = true
      this.loading = true
      bdBonusMemberSellChinas({...this.listQuery}).then(res => {
        this.list = res.data.records
        this.total = +res.data.total
        this.listLoading = false
        this.loading = false
        this.btnLoading = false
      }).catch(() => {
        this.$message.error('查询失败')
        this.listLoading = false
        this.btnLoading = false
        this.loading = false
      })
    },
    // 查询
    handleFilter() {
      this.getList()
    },
    // 期次
    getWeeks() {
      // this.wWeekLoading = true
      // this.btnLoading = true
      // getwWeek().then(res => {
      //   this.listdata = res.data
      //   this.listQuery.fromWeek = res.data[0].chinaWWeek
      //   this.listQuery.toWeek = res.data[0].chinaWWeek
      //   this.wWeekLoading = false
      //   this.btnLoading = false
      // })
    },
  }
}
</script>

<style>

</style>
